import type { NormalToken } from '@ui/config/token/types';
import { Fraction } from 'bi-fraction';

import {
  isNormalToken,
  type TokenOption,
  type TokenPriceFetcher,
} from '../types';

export const cdcTokenFetcher: TokenPriceFetcher = {
  fetchPrice: async (token: TokenOption) => {
    if (!isNormalToken(token)) throw new Error('Token is not a normal token');
    const handle = TOKEN_HANDLE_MAP[token];
    const response = await (
      await fetch(`https://price-api.crypto.com/price/v1/token-price/${handle}`)
    ).json();
    return {
      usd_price: new Fraction(response.usd_price),
      usd_price_change_24h: new Fraction(response.usd_price_change_24h),
    };
  },
  supportsToken: (token: TokenOption) => {
    return isNormalToken(token) && token in TOKEN_HANDLE_MAP;
  },
};

const TOKEN_HANDLE_MAP: Partial<Record<NormalToken, string>> = {
  zkCRO: 'zkcro-cdc',
  wzkCRO: 'zkcro-cdc',
  wCRO: 'cronos',
} as const;
